// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 데이터 가져오기 모달 — 내보내기 모달과 같은 톤. 색 전용 transition, reduced-motion 가드 */

.import-modal-overlay {
  position: fixed;
  inset: 0;
  background: var(--color-overlay-bg, rgba(0, 0, 0, 0.5));
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
}

.import-modal {
  width: 640px;
  max-width: calc(calc(100vw / var(--app-zoom, 1)) - 32px);
  max-height: calc(calc(100vh / var(--app-zoom, 1)) - 64px);
  display: flex;
  flex-direction: column;
  background: #fff;
  color: #374151;
  border-radius: 10px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.28);
  animation: import-modal-in 160ms ease-out;
}

@keyframes import-modal-in {
  from { opacity: 0; transform: translateY(-3px); }
  to   { opacity: 1; transform: translateY(0); }
}

.import-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  border-bottom: 1px solid #e5e7eb;
}

.import-modal-header h2 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 7px;
}

.import-modal-close {
  border: none;
  background: none;
  color: inherit;
  cursor: pointer;
  padding: 2px;
  border-radius: 4px;
  transition: background-color 150ms ease;
}

.import-modal-close:hover { background: rgba(0, 0, 0, 0.06); }

/* 단계 표시 */
.import-steps {
  display: flex;
  gap: 6px;
  padding: 10px 18px;
  border-bottom: 1px solid #e5e7eb;
  font-size: 12px;
}

.import-step {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  color: #9ca3af;
  transition: background-color 150ms ease, color 150ms ease;
}

.import-step-no {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 17px;
  height: 17px;
  border-radius: 50%;
  background: #e5e7eb;
  color: #6b7280;
  font-size: 10px;
  font-weight: 700;
}

.import-step.active { background: rgba(59, 130, 246, 0.1); color: #1d4ed8; }
.import-step.active .import-step-no { background: #3b82f6; color: #fff; }
.import-step.done { color: #6b7280; }
.import-step.done .import-step-no { background: #10b981; color: #fff; }

.import-modal-body {
  padding: 16px 18px;
  overflow-y: auto;
  flex: 1 1;
}

.import-pane {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.import-field {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
}

.import-label {
  flex-shrink: 0;
  width: 76px;
  font-size: 12px;
  color: #6b7280;
}

.import-field input[type="text"],
.import-field input[type="number"],
.import-field input[type="file"],
.import-field select {
  flex: 1 1;
  min-width: 0;
  padding: 6px 9px;
  font-size: 13px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  color: inherit;
  transition: border-color 150ms ease;
}

.import-field input:focus,
.import-field select:focus { outline: none; border-color: #3b82f6; }

.import-checks {
  display: flex;
  flex-direction: column;
  gap: 7px;
  font-size: 13px;
  padding-left: 86px;
}

.import-checks label { display: flex; align-items: center; gap: 7px; cursor: pointer; }

.import-hint { font-size: 11px; color: #9ca3af; }

.import-summary {
  display: flex;
  align-items: baseline;
  gap: 10px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 12px;
}

.import-target {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}

.import-target .import-field { flex: 1 1; min-width: 200px; }

.import-map-head { font-size: 13px; font-weight: 600; }

.import-map-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
  max-height: 220px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 8px;
}

.import-map-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}

.import-csv-col {
  flex: 0 0 34%;
  font-family: 'Consolas', 'Monaco', monospace;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.import-arrow { color: #9ca3af; flex-shrink: 0; }

.import-map-row select {
  flex: 1 1;
  min-width: 0;
  padding: 4px 7px;
  font-size: 12px;
  border: 1px solid #d1d5db;
  border-radius: 5px;
  background: #fff;
  color: inherit;
}

.import-preview summary {
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
}

.import-preview-scroll {
  margin-top: 8px;
  max-height: 200px;
  overflow: auto;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
}

.import-preview table { border-collapse: collapse; width: 100%; font-size: 11px; }

.import-preview th,
.import-preview td {
  border-bottom: 1px solid #f3f4f6;
  padding: 4px 8px;
  text-align: left;
  white-space: nowrap;
}

.import-preview th { position: sticky; top: 0; background: #f9fafb; color: #6b7280; }

.import-note,
.import-warn {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 11px;
  line-height: 1.6;
  border-radius: 6px;
  padding: 8px 10px;
}

.import-note { color: #6b7280; background: #eff6ff; border: 1px solid #bfdbfe; }
.import-note code { font-family: 'Consolas', 'Monaco', monospace; }

/* 되돌릴 수 없는 쓰기 작업이라 경고 톤을 분명히 준다 */
.import-warn { color: #92400e; background: #fffbeb; border: 1px solid #fcd34d; font-size: 12px; }

.import-result {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 12px;
  border-radius: 6px;
}

.import-result.ok { background: #ecfdf5; border: 1px solid #6ee7b7; color: #065f46; }
.import-result.fail { background: #fee2e2; border: 1px solid #fca5a5; color: #991b1b; }

.import-result-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 8px;
}

.import-result-stats > div {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.import-result-stats span { font-size: 11px; color: #6b7280; }
.import-result-stats strong { font-size: 14px; }

.import-error {
  margin-top: 12px;
  background: #fee2e2;
  border: 1px solid #fca5a5;
  color: #991b1b;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 12px;
}

.import-modal-footer {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 18px;
  border-top: 1px solid #e5e7eb;
}

.import-footer-spacer { flex: 1 1; }

.import-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 7px 14px;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #f3f4f6;
  color: #374151;
  cursor: pointer;
  transition: background-color 150ms ease, border-color 150ms ease;
}

.import-btn:hover { background: #e5e7eb; }
.import-btn:disabled { opacity: 0.55; cursor: not-allowed; }

.import-btn-primary { background: #3b82f6; border-color: transparent; color: #fff; }
.import-btn-primary:hover { background: #2563eb; }

/* 실행 버튼은 쓰기 작업이라 색을 달리해 오조작을 줄인다 */
.import-btn-danger { background: #d97706; border-color: transparent; color: #fff; }
.import-btn-danger:hover { background: #b45309; }

@media (prefers-reduced-motion: reduce) {
  .import-modal { animation: none; }
  .import-modal-close, .import-btn, .import-step,
  .import-field input, .import-field select { transition: none; }
}

/* 다크 모드 */
[data-theme="dark"] .import-modal { background: var(--color-bg-tertiary); color: var(--color-text); }

[data-theme="dark"] .import-modal-header,
[data-theme="dark"] .import-modal-footer,
[data-theme="dark"] .import-steps { border-color: var(--color-border); }

[data-theme="dark"] .import-modal-close:hover { background: var(--color-hover); }

[data-theme="dark"] .import-label,
[data-theme="dark"] .import-hint,
[data-theme="dark"] .import-arrow,
[data-theme="dark"] .import-result-stats span { color: var(--color-text-muted); }

[data-theme="dark"] .import-field input,
[data-theme="dark"] .import-field select,
[data-theme="dark"] .import-map-row select {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
  color: var(--color-text);
}

[data-theme="dark"] .import-summary,
[data-theme="dark"] .import-result-stats > div,
[data-theme="dark"] .import-map-list,
[data-theme="dark"] .import-preview-scroll {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
}

[data-theme="dark"] .import-preview th {
  background: var(--color-bg-secondary);
  color: var(--color-text-muted);
}

[data-theme="dark"] .import-preview th,
[data-theme="dark"] .import-preview td { border-bottom-color: var(--color-border); }

[data-theme="dark"] .import-step-no { background: var(--color-border); color: var(--color-text-muted); }
[data-theme="dark"] .import-step.active { background: rgba(59, 130, 246, 0.18); color: #93c5fd; }

[data-theme="dark"] .import-note {
  background: rgba(59, 130, 246, 0.1);
  border-color: rgba(59, 130, 246, 0.3);
  color: var(--color-text-muted);
}

[data-theme="dark"] .import-warn {
  background: rgba(251, 191, 36, 0.12);
  border-color: rgba(251, 191, 36, 0.35);
  color: #fbbf24;
}

[data-theme="dark"] .import-result.ok {
  background: rgba(16, 185, 129, 0.12);
  border-color: rgba(16, 185, 129, 0.35);
  color: #6ee7b7;
}

[data-theme="dark"] .import-result.fail,
[data-theme="dark"] .import-error {
  background: rgba(248, 113, 113, 0.12);
  border-color: rgba(248, 113, 113, 0.3);
  color: #fca5a5;
}

[data-theme="dark"] .import-btn {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
  color: var(--color-text);
}

[data-theme="dark"] .import-btn:hover { background: var(--color-hover); }
[data-theme="dark"] .import-btn-primary { background: var(--color-accent); border-color: transparent; color: #fff; }
`, "",{"version":3,"sources":["webpack://./src/components/ImportDataModal.css"],"names":[],"mappings":"AAAA,oEAAoE;;AAEpE;EACE,eAAe;EACf,QAAQ;EACR,uDAAuD;EACvD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,wDAAwD;EACxD,yDAAyD;EACzD,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,4BAA4B,+BAA+B,EAAE;;AAE7D,UAAU;AACV;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,yDAAyD;AAC3D;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,sBAAsB,mCAAmC,EAAE,cAAc,EAAE;AAC3E,sCAAsC,mBAAmB,EAAE,WAAW,EAAE;AACxE,oBAAoB,cAAc,EAAE;AACpC,oCAAoC,mBAAmB,EAAE,WAAW,EAAE;;AAEtE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;;;;EAIE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mCAAmC;AACrC;;AAEA;6BAC6B,aAAa,EAAE,qBAAqB,EAAE;;AAEnE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;;AAEA,uBAAuB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE;;AAEtF,eAAe,eAAe,EAAE,cAAc,EAAE;;AAEhD;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;;AAEA,+BAA+B,SAAO,EAAE,gBAAgB,EAAE;;AAE1D,mBAAmB,eAAe,EAAE,gBAAgB,EAAE;;AAEtD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,gBAAgB,cAAc,EAAE,cAAc,EAAE;;AAEhD;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,wBAAwB,yBAAyB,EAAE,WAAW,EAAE,eAAe,EAAE;;AAEjF;;EAEE,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,qBAAqB,gBAAgB,EAAE,MAAM,EAAE,mBAAmB,EAAE,cAAc,EAAE;;AAEpF;;EAEE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,eAAe,cAAc,EAAE,mBAAmB,EAAE,yBAAyB,EAAE;AAC/E,oBAAoB,4CAA4C,EAAE;;AAElE,kCAAkC;AAClC,eAAe,cAAc,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,eAAe,EAAE;;AAEhG;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,oBAAoB,mBAAmB,EAAE,yBAAyB,EAAE,cAAc,EAAE;AACpF,sBAAsB,mBAAmB,EAAE,yBAAyB,EAAE,cAAc,EAAE;;AAEtF;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,4BAA4B,eAAe,EAAE,cAAc,EAAE;AAC7D,8BAA8B,eAAe,EAAE;;AAE/C;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA,wBAAwB,SAAO,EAAE;;AAEjC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gEAAgE;AAClE;;AAEA,oBAAoB,mBAAmB,EAAE;AACzC,uBAAuB,aAAa,EAAE,mBAAmB,EAAE;;AAE3D,sBAAsB,mBAAmB,EAAE,yBAAyB,EAAE,WAAW,EAAE;AACnF,4BAA4B,mBAAmB,EAAE;;AAEjD,mCAAmC;AACnC,qBAAqB,mBAAmB,EAAE,yBAAyB,EAAE,WAAW,EAAE;AAClF,2BAA2B,mBAAmB,EAAE;;AAEhD;EACE,gBAAgB,eAAe,EAAE;EACjC;8CAC4C,gBAAgB,EAAE;AAChE;;AAEA,UAAU;AACV,oCAAoC,oCAAoC,EAAE,wBAAwB,EAAE;;AAEpG;;oCAEoC,iCAAiC,EAAE;;AAEvE,gDAAgD,8BAA8B,EAAE;;AAEhF;;;gDAGgD,8BAA8B,EAAE;;AAEhF;;;EAGE,qCAAqC;EACrC,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;;;;EAIE,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;yCACyC,wCAAwC,EAAE;;AAEnF,sCAAsC,+BAA+B,EAAE,8BAA8B,EAAE;AACvG,0CAA0C,oCAAoC,EAAE,cAAc,EAAE;;AAEhG;EACE,mCAAmC;EACnC,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;EACrC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA,wCAAwC,8BAA8B,EAAE;AACxE,0CAA0C,+BAA+B,EAAE,yBAAyB,EAAE,WAAW,EAAE","sourcesContent":["/* 데이터 가져오기 모달 — 내보내기 모달과 같은 톤. 색 전용 transition, reduced-motion 가드 */\r\n\r\n.import-modal-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: var(--color-overlay-bg, rgba(0, 0, 0, 0.5));\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1200;\r\n}\r\n\r\n.import-modal {\r\n  width: 640px;\r\n  max-width: calc(calc(100vw / var(--app-zoom, 1)) - 32px);\r\n  max-height: calc(calc(100vh / var(--app-zoom, 1)) - 64px);\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: #fff;\r\n  color: #374151;\r\n  border-radius: 10px;\r\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.28);\r\n  animation: import-modal-in 160ms ease-out;\r\n}\r\n\r\n@keyframes import-modal-in {\r\n  from { opacity: 0; transform: translateY(-3px); }\r\n  to   { opacity: 1; transform: translateY(0); }\r\n}\r\n\r\n.import-modal-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 14px 18px;\r\n  border-bottom: 1px solid #e5e7eb;\r\n}\r\n\r\n.import-modal-header h2 {\r\n  margin: 0;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n}\r\n\r\n.import-modal-close {\r\n  border: none;\r\n  background: none;\r\n  color: inherit;\r\n  cursor: pointer;\r\n  padding: 2px;\r\n  border-radius: 4px;\r\n  transition: background-color 150ms ease;\r\n}\r\n\r\n.import-modal-close:hover { background: rgba(0, 0, 0, 0.06); }\r\n\r\n/* 단계 표시 */\r\n.import-steps {\r\n  display: flex;\r\n  gap: 6px;\r\n  padding: 10px 18px;\r\n  border-bottom: 1px solid #e5e7eb;\r\n  font-size: 12px;\r\n}\r\n\r\n.import-step {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 4px 10px;\r\n  border-radius: 999px;\r\n  color: #9ca3af;\r\n  transition: background-color 150ms ease, color 150ms ease;\r\n}\r\n\r\n.import-step-no {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 17px;\r\n  height: 17px;\r\n  border-radius: 50%;\r\n  background: #e5e7eb;\r\n  color: #6b7280;\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n}\r\n\r\n.import-step.active { background: rgba(59, 130, 246, 0.1); color: #1d4ed8; }\r\n.import-step.active .import-step-no { background: #3b82f6; color: #fff; }\r\n.import-step.done { color: #6b7280; }\r\n.import-step.done .import-step-no { background: #10b981; color: #fff; }\r\n\r\n.import-modal-body {\r\n  padding: 16px 18px;\r\n  overflow-y: auto;\r\n  flex: 1;\r\n}\r\n\r\n.import-pane {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.import-field {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  font-size: 13px;\r\n}\r\n\r\n.import-label {\r\n  flex-shrink: 0;\r\n  width: 76px;\r\n  font-size: 12px;\r\n  color: #6b7280;\r\n}\r\n\r\n.import-field input[type=\"text\"],\r\n.import-field input[type=\"number\"],\r\n.import-field input[type=\"file\"],\r\n.import-field select {\r\n  flex: 1;\r\n  min-width: 0;\r\n  padding: 6px 9px;\r\n  font-size: 13px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  background: #fff;\r\n  color: inherit;\r\n  transition: border-color 150ms ease;\r\n}\r\n\r\n.import-field input:focus,\r\n.import-field select:focus { outline: none; border-color: #3b82f6; }\r\n\r\n.import-checks {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 7px;\r\n  font-size: 13px;\r\n  padding-left: 86px;\r\n}\r\n\r\n.import-checks label { display: flex; align-items: center; gap: 7px; cursor: pointer; }\r\n\r\n.import-hint { font-size: 11px; color: #9ca3af; }\r\n\r\n.import-summary {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 10px;\r\n  background: #f9fafb;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 6px;\r\n  padding: 8px 12px;\r\n  font-size: 12px;\r\n}\r\n\r\n.import-target {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.import-target .import-field { flex: 1; min-width: 200px; }\r\n\r\n.import-map-head { font-size: 13px; font-weight: 600; }\r\n\r\n.import-map-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n  max-height: 220px;\r\n  overflow-y: auto;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 6px;\r\n  padding: 8px;\r\n}\r\n\r\n.import-map-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 12px;\r\n}\r\n\r\n.import-csv-col {\r\n  flex: 0 0 34%;\r\n  font-family: 'Consolas', 'Monaco', monospace;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.import-arrow { color: #9ca3af; flex-shrink: 0; }\r\n\r\n.import-map-row select {\r\n  flex: 1;\r\n  min-width: 0;\r\n  padding: 4px 7px;\r\n  font-size: 12px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 5px;\r\n  background: #fff;\r\n  color: inherit;\r\n}\r\n\r\n.import-preview summary {\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n}\r\n\r\n.import-preview-scroll {\r\n  margin-top: 8px;\r\n  max-height: 200px;\r\n  overflow: auto;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 6px;\r\n}\r\n\r\n.import-preview table { border-collapse: collapse; width: 100%; font-size: 11px; }\r\n\r\n.import-preview th,\r\n.import-preview td {\r\n  border-bottom: 1px solid #f3f4f6;\r\n  padding: 4px 8px;\r\n  text-align: left;\r\n  white-space: nowrap;\r\n}\r\n\r\n.import-preview th { position: sticky; top: 0; background: #f9fafb; color: #6b7280; }\r\n\r\n.import-note,\r\n.import-warn {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 6px;\r\n  font-size: 11px;\r\n  line-height: 1.6;\r\n  border-radius: 6px;\r\n  padding: 8px 10px;\r\n}\r\n\r\n.import-note { color: #6b7280; background: #eff6ff; border: 1px solid #bfdbfe; }\r\n.import-note code { font-family: 'Consolas', 'Monaco', monospace; }\r\n\r\n/* 되돌릴 수 없는 쓰기 작업이라 경고 톤을 분명히 준다 */\r\n.import-warn { color: #92400e; background: #fffbeb; border: 1px solid #fcd34d; font-size: 12px; }\r\n\r\n.import-result {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  padding: 10px 12px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.import-result.ok { background: #ecfdf5; border: 1px solid #6ee7b7; color: #065f46; }\r\n.import-result.fail { background: #fee2e2; border: 1px solid #fca5a5; color: #991b1b; }\r\n\r\n.import-result-stats {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\r\n  gap: 8px;\r\n}\r\n\r\n.import-result-stats > div {\r\n  background: #f9fafb;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 6px;\r\n  padding: 8px 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 3px;\r\n}\r\n\r\n.import-result-stats span { font-size: 11px; color: #6b7280; }\r\n.import-result-stats strong { font-size: 14px; }\r\n\r\n.import-error {\r\n  margin-top: 12px;\r\n  background: #fee2e2;\r\n  border: 1px solid #fca5a5;\r\n  color: #991b1b;\r\n  border-radius: 6px;\r\n  padding: 8px 12px;\r\n  font-size: 12px;\r\n}\r\n\r\n.import-modal-footer {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 12px 18px;\r\n  border-top: 1px solid #e5e7eb;\r\n}\r\n\r\n.import-footer-spacer { flex: 1; }\r\n\r\n.import-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  padding: 7px 14px;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  background: #f3f4f6;\r\n  color: #374151;\r\n  cursor: pointer;\r\n  transition: background-color 150ms ease, border-color 150ms ease;\r\n}\r\n\r\n.import-btn:hover { background: #e5e7eb; }\r\n.import-btn:disabled { opacity: 0.55; cursor: not-allowed; }\r\n\r\n.import-btn-primary { background: #3b82f6; border-color: transparent; color: #fff; }\r\n.import-btn-primary:hover { background: #2563eb; }\r\n\r\n/* 실행 버튼은 쓰기 작업이라 색을 달리해 오조작을 줄인다 */\r\n.import-btn-danger { background: #d97706; border-color: transparent; color: #fff; }\r\n.import-btn-danger:hover { background: #b45309; }\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .import-modal { animation: none; }\r\n  .import-modal-close, .import-btn, .import-step,\r\n  .import-field input, .import-field select { transition: none; }\r\n}\r\n\r\n/* 다크 모드 */\r\n[data-theme=\"dark\"] .import-modal { background: var(--color-bg-tertiary); color: var(--color-text); }\r\n\r\n[data-theme=\"dark\"] .import-modal-header,\r\n[data-theme=\"dark\"] .import-modal-footer,\r\n[data-theme=\"dark\"] .import-steps { border-color: var(--color-border); }\r\n\r\n[data-theme=\"dark\"] .import-modal-close:hover { background: var(--color-hover); }\r\n\r\n[data-theme=\"dark\"] .import-label,\r\n[data-theme=\"dark\"] .import-hint,\r\n[data-theme=\"dark\"] .import-arrow,\r\n[data-theme=\"dark\"] .import-result-stats span { color: var(--color-text-muted); }\r\n\r\n[data-theme=\"dark\"] .import-field input,\r\n[data-theme=\"dark\"] .import-field select,\r\n[data-theme=\"dark\"] .import-map-row select {\r\n  background: var(--color-bg-secondary);\r\n  border-color: var(--color-border);\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .import-summary,\r\n[data-theme=\"dark\"] .import-result-stats > div,\r\n[data-theme=\"dark\"] .import-map-list,\r\n[data-theme=\"dark\"] .import-preview-scroll {\r\n  background: var(--color-bg-secondary);\r\n  border-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .import-preview th {\r\n  background: var(--color-bg-secondary);\r\n  color: var(--color-text-muted);\r\n}\r\n\r\n[data-theme=\"dark\"] .import-preview th,\r\n[data-theme=\"dark\"] .import-preview td { border-bottom-color: var(--color-border); }\r\n\r\n[data-theme=\"dark\"] .import-step-no { background: var(--color-border); color: var(--color-text-muted); }\r\n[data-theme=\"dark\"] .import-step.active { background: rgba(59, 130, 246, 0.18); color: #93c5fd; }\r\n\r\n[data-theme=\"dark\"] .import-note {\r\n  background: rgba(59, 130, 246, 0.1);\r\n  border-color: rgba(59, 130, 246, 0.3);\r\n  color: var(--color-text-muted);\r\n}\r\n\r\n[data-theme=\"dark\"] .import-warn {\r\n  background: rgba(251, 191, 36, 0.12);\r\n  border-color: rgba(251, 191, 36, 0.35);\r\n  color: #fbbf24;\r\n}\r\n\r\n[data-theme=\"dark\"] .import-result.ok {\r\n  background: rgba(16, 185, 129, 0.12);\r\n  border-color: rgba(16, 185, 129, 0.35);\r\n  color: #6ee7b7;\r\n}\r\n\r\n[data-theme=\"dark\"] .import-result.fail,\r\n[data-theme=\"dark\"] .import-error {\r\n  background: rgba(248, 113, 113, 0.12);\r\n  border-color: rgba(248, 113, 113, 0.3);\r\n  color: #fca5a5;\r\n}\r\n\r\n[data-theme=\"dark\"] .import-btn {\r\n  background: var(--color-bg-secondary);\r\n  border-color: var(--color-border);\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .import-btn:hover { background: var(--color-hover); }\r\n[data-theme=\"dark\"] .import-btn-primary { background: var(--color-accent); border-color: transparent; color: #fff; }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
